"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHint = exports.djbIntHash = exports.blakeHash = void 0;
/*
Copyright 2018 - 2022 The Alephium Authors
This file is part of the alephium project.

The library is free software: you can redistribute it and/or modify
it under the terms of the GNU Lesser General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

The library is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Lesser General Public License for more details.

You should have received a copy of the GNU Lesser General Public License
along with the library. If not, see <http://www.gnu.org/licenses/>.
*/
const blakejs_1 = __importDefault(require("blakejs"));
function blakeHash(raw) {
    return blakejs_1.default.blake2b(raw, undefined, 32);
}
exports.blakeHash = blakeHash;
function djbIntHash(bytes) {
    let hash = 5381;
    bytes.forEach((byte) => {
        hash = (hash << 5) + hash + (byte & 0xff);
    });
    return hash;
}
exports.djbIntHash = djbIntHash;
function createHint(input) {
    return djbIntHash(input) | 1;
}
exports.createHint = createHint;
